import { instance, next } from "./base";

export const getCategories = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/categories")
    .catch((e) => next(e));
  return data?.data;
};

export const addCategories = async (values) => {
  const { data } = await instance()
    .post("/api/v1/admin/categories", values)
    .catch((e) => next(e));
  return data?.data;
};

export const updateCategories = async (values) => {
  const id = values.id;
  delete values.id;

  const { data } = await instance()
    .patch(`/api/v1/admin/categories/${id}`, values)
    .catch((e) => next(e));
  return data?.data;
};


export const getProducts = async (search) => {
  const { data } = await instance()
    .get("/api/v1/admin/products", { params: { ...(search && { search }) } })
    .catch((e) => next(e));
  return data?.data?.products;
};

export const getProduct = async (id) => {
  const { data } = await instance()
    .get(`/api/v1/admin/products/${id}`)
    .catch((e) => next(e));
  return data?.data;
};

export const createProduct = async (values) => {
  const { data } = await instance(true)
    .post("/api/v1/admin/add/product", values)
    .catch((e) => next(e));
  return data?.data;
};

export const editProduct = async (values) => {
  const id = values.id;
  delete values.id;
  const { data } = await instance(true)
    .post(`/api/v1/admin/products/${id}`, values)
    .catch((e) => next(e));
  return data?.data;
};


export const deleteProduct = async (values) => {
  const { data } = await instance(true)
    .delete(`/api/v1/admin/products/${values.id}`)
    .catch((e) => next(e));
  return data?.data;
};
